import axios from '@/libs/axios';

const TenantService = {
  async getInfo() {
    const response = await axios.get('/tenants/info');
    return response.data;
  },

  async listar() {
    const response = await axios.get('/tenants');
    return response.data;
  },

  async buscar(id) {
    const response = await axios.get(`/tenants/${id}`);
    return response.data;
  },

  async criar(dados) {
    const response = await axios.post('/tenants', dados);
    return response.data;
  },

  async atualizar(id, dados) {
    const response = await axios.put(`/tenants/${id}`, dados);
    return response.data;
  },

  async desativar(id) {
    const response = await axios.delete(`/tenants/${id}`);
    return response.data;
  },

  async testarConexao(id) {
    const response = await axios.post(`/tenants/${id}/testar-conexao`);
    return response.data;
  },

  /**
   * Provisiona o banco do tenant: cria todas as tabelas que ainda não existem.
   * Seguro para bancos já existentes.
   */
  async provisionar(id) {
    const response = await axios.post(`/tenants/${id}/provisionar`);
    return response.data;
  },
};

export default TenantService;
